// extracted by mini-css-extract-plugin
module.exports = {"teaserContainer":"document-teaser-block-module--teaserContainer--2p9Ju","blockContainer":"document-teaser-block-module--blockContainer--2DL5Y"};